import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_2 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_3 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_4 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "BidsListFilters bg-white border px-4 py-2",
    onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_input, {
          value: _ctx.state.id,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.id) = $event)),
          placeholder: "Номер заявки"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.route,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.route) = $event)),
          placeholder: "Маршрут"
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Перевозчик",
          loading: _ctx.data_state.carriers.is_loading,
          failed: _ctx.data_state.carriers.is_failed,
          "error-text": "При получении списка перевозчиков произошла ошибка",
          options: _ctx.data_state.carriers.list,
          value: _ctx.state.carrierId,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.carrierId) = $event)),
          onRefresh: _ctx.loadCarriers,
          onLoadmore: _ctx.loadMoreCarriers,
          class: "mt-2"
        }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "onLoadmore"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Создатель",
          loading: _ctx.data_state.users.is_loading,
          failed: _ctx.data_state.users.is_failed,
          "error-text": "При получении списка создателей произошла ошибка",
          options: _ctx.data_state.users.list,
          value: _ctx.state.userId,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.userId) = $event)),
          onRefresh: _ctx.loadUsers,
          onLoadmore: _ctx.loadMoreUsers,
          class: "mt-2"
        }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "onLoadmore"]),
        _createVNode(_component_the_input, {
          type: "date",
          placeholder: "Дата создания",
          value: _ctx.state.dateOfCreation,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.dateOfCreation) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Статус",
          loading: _ctx.data_state.statuses.is_loading,
          failed: _ctx.data_state.statuses.is_failed,
          "error-text": "При получении списка произошла ошибка",
          options: _ctx.data_state.statuses.list,
          value: _ctx.state.statusId,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.statusId) = $event)),
          onRefresh: _ctx.loadStatuses,
          "select-by": "id",
          searchable: false,
          class: "mt-2"
        }, null, 8, ["loading", "failed", "options", "value", "onRefresh"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isFtl)
          ? (_openBlock(), _createBlock(_component_the_select, {
              key: 0,
              "can-deselect": "",
              placeholder: "Догруз",
              options: _ctx.IS_ADDITTIONAL_LOAD_OPTIONS,
              value: _ctx.state.isAdditionalLoad,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.isAdditionalLoad) = $event)),
              "select-by": "id",
              searchable: false
            }, null, 8, ["options", "value"]))
          : _createCommentVNode("", true),
        (!_ctx.isFtl)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 1,
              label: "Выше нормы себестоимости",
              value: _ctx.state.isAboveCostStandard,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.isAboveCostStandard) = $event)),
              "return-integer": ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (!_ctx.isFtl)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 2,
              label: "Проект",
              value: _ctx.state.isProject,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.isProject) = $event)),
              "return-integer": ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_the_button, {
        class: "second text small mt-2",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small mt-2",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}